import React from 'react';
import PropTypes from 'prop-types';
import ErrorMessageField from 'components/field/MessageField/ErrorMessageField';
import { hasValidProductConfiguration, invalidProductConfigurations } from 'helpers/product';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const ProductResourceNotification = (props) => {
    const {
        data,
        translate,
    } = props;

    if (utils.isEmpty(data) || data.enabled) {
        return null;
    }

    let translationKey = null;

    const hasValidConfiguration = hasValidProductConfiguration(data.configuration);

    if (!data.resource && !hasValidConfiguration) {
        translationKey = 'product_missing_data';
    } else if (!data.resource && hasValidConfiguration) {
        translationKey = 'resource';
    } else if (data.resource && !hasValidConfiguration) {
        translationKey = 'configuration';

        const invalidConfigurations = Object.keys(invalidProductConfigurations(data.configuration));

        if (invalidConfigurations.length === 1) {
            translationKey = invalidConfigurations[0];
        }
    }

    if (!translationKey) {
        return null;
    }

    return (
        <ErrorMessageField>
            { translate(`resources.products.notifications.${ translationKey }`) }
        </ErrorMessageField>
    );
};

ProductResourceNotification.propTypes = {
    data: PropTypes.shape({
        configuration: PropTypes.oneOfType([
            PropTypes.array, // Saving an empty configuration returns an empty array
            PropTypes.shape({
                vat_percentage: PropTypes.number,
            }),
        ]),
        enabled: PropTypes.bool,
        resource: PropTypes.object,
    }).isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(ProductResourceNotification);


// WEBPACK FOOTER //
// ./src/components/notifications/ProductResourceNotification.js